import React from "react";

function IllustrationOnlineValuations() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 104 96">
      <path
        d="M103.855 92.335l-100.364.174V0H0v94.254c0 .524.175.873.524 1.222.349.35.698.524 1.221.524l102.11-.174v-3.491z"
        className="fill-secondary"
      />
      <path
        d="M65.978 53.062c7.506 0 13.79-6.11 13.79-13.79 0-7.68-6.11-13.788-13.79-13.788-7.68 0-13.79 6.109-13.79 13.789s6.11 13.789 13.79 13.789zm0-12.916c-2.444-.175-4.887-.699-4.887-3.84 0-2.27 1.92-3.491 4.014-3.666v-1.396h2.27v1.396c1.396.175 2.792.873 3.665 2.444l-2.095 1.047c-.349-.698-1.396-1.396-2.792-1.396-1.222 0-2.444.523-2.444 1.57 0 1.048 1.222 1.222 2.444 1.397 2.443.349 5.236 1.047 5.236 4.189 0 2.269-1.396 3.665-4.015 4.015v1.745h-2.269v-1.745c-1.92-.175-3.84-1.397-4.538-3.142l2.27-1.048c.523 1.048 1.92 1.92 3.316 1.92 1.57 0 2.792-.174 2.792-1.57-.174-1.222-1.396-1.746-2.967-1.92z"
        className="fill-primary"
      />
      <path
        d="M8.727 69.644c.35.174.698.174.873.174.524 0 1.222-.349 1.57-.873 0-.174 6.11-9.949 16.757-9.949 7.331 0 12.917 1.746 18.677 3.491 5.76 1.746 11.694 3.491 19.374 3.491 13.091 0 23.215-9.25 28.975-26.705 4.363-12.917 4.887-25.484 4.887-26.008 0-1.047-.698-1.745-1.746-1.745-.872 0-1.745.698-1.745 1.745 0 .524-2.269 49.397-30.37 49.397-7.332 0-12.743-1.571-18.503-3.316-5.76-1.746-11.694-3.491-19.549-3.491-12.567 0-19.374 11.17-19.723 11.694-.524.524-.35 1.571.523 2.095z"
        className="fill-secondary"
      />
    </svg>
  );
}

export default IllustrationOnlineValuations;
